var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReceiver = function SvgReceiver(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-friend (1) 1",
    clipPath: "url(#clip0_1143_29958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.125 3C2.125 1.69 3.19 0.625 4.5 0.625C5.81 0.625 6.875 1.69 6.875 3C6.875 4.31 5.81 5.375 4.5 5.375C3.19 5.375 2.125 4.31 2.125 3ZM6.375 9.625H6C5.38 9.625 4.875 9.12 4.875 8.5C4.875 7.88 5.38 7.375 6 7.375H6.375V7C6.375 6.695 6.495 6.42 6.695 6.215C6.47 6.155 6.24 6.125 6 6.125H3C1.415 6.125 0.125 7.415 0.125 9C0.125 9.76 0.74 10.375 1.5 10.375H6.44C6.4 10.26 6.375 10.13 6.375 10V9.625ZM8.625 9.79C8.66 9.735 8.695 9.685 8.725 9.625H8.625V9.79ZM9 8.125H7.875V7C7.875 6.793 7.707 6.625 7.5 6.625C7.293 6.625 7.125 6.793 7.125 7V8.125H6C5.793 8.125 5.625 8.293 5.625 8.5C5.625 8.707 5.793 8.875 6 8.875H7.125V10C7.125 10.207 7.293 10.375 7.5 10.375C7.707 10.375 7.875 10.207 7.875 10V8.875H9C9.207 8.875 9.375 8.707 9.375 8.5C9.375 8.293 9.207 8.125 9 8.125Z",
    fill: "#9AA5AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1143_29958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.5,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReceiver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "receiver.5e29271c59941ce80993fb72c4da8119.svg";